$(document).ready(function () {
  //replace with / collapsable class / collapsable-content
  $('.recipe-ingredients:not(.bound)')
    .addClass('bound')
    .click(function (e) {
      e.preventDefault();
      $('.recipe-ingredients-data').animate(
        {
          height: 'toggle'
        },
        300,
        'linear'
      );
    });
  $('.recipe-preparation:not(.bound)')
    .addClass('bound')
    .click(function (e) {
      e.preventDefault();
      $('.recipe-preparation-data').animate(
        {
          height: 'toggle'
        },
        300,
        'linear'
      );
    });
});
